module.exports = __webpack_public_path__ + "img/prop-tv-4-left.eabf5393.png";